// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3wHR2","label":"styles_label__wfTXy"};